module.exports = __webpack_public_path__ + "static/media/female.2f794f0f.png";